import { render, staticRenderFns } from "./labelManageDetail.vue?vue&type=template&id=13ea55af&scoped=true&"
import script from "./labelManageDetail.vue?vue&type=script&lang=js&"
export * from "./labelManageDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ea55af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13ea55af')) {
      api.createRecord('13ea55af', component.options)
    } else {
      api.reload('13ea55af', component.options)
    }
    module.hot.accept("./labelManageDetail.vue?vue&type=template&id=13ea55af&scoped=true&", function () {
      api.rerender('13ea55af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/client/labelManage/labelManageDetail.vue"
export default component.exports